var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1196 1H1.3806C1.17042 1 1 1.17015 1 1.38V19.62C1 19.7208 1.0401 19.8175 1.11146 19.8887C1.18282 19.96 1.27967 20 1.3806 20H16.1196C16.2205 20 16.3173 19.96 16.3887 19.8887C16.4601 19.8175 16.5002 19.7208 16.5002 19.62V1.38C16.5002 1.27923 16.4601 1.18253 16.3887 1.11129C16.3173 1.04004 16.2205 1 16.1196 1ZM15.739 19.24H1.76119V1.76H15.739V19.24Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49344 4.97038H13.0072C13.2136 4.97038 13.381 4.77991 13.381 4.545C13.381 4.3101 13.2136 4.11963 13.0072 4.11963H4.49344C4.28701 4.11963 4.11963 4.3101 4.11963 4.545C4.11963 4.77991 4.28701 4.97038 4.49344 4.97038Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49344 7.80631H13.0072C13.2136 7.80631 13.381 7.61584 13.381 7.38094C13.381 7.14604 13.2136 6.95557 13.0072 6.95557H4.49344C4.28701 6.95557 4.11963 7.14604 4.11963 7.38094C4.11963 7.61584 4.28701 7.80631 4.49344 7.80631Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49344 10.6418H13.0072C13.2136 10.6418 13.381 10.4513 13.381 10.2164C13.381 9.98149 13.2136 9.79102 13.0072 9.79102H4.49344C4.28701 9.79102 4.11963 9.98149 4.11963 10.2164C4.11963 10.4513 4.28701 10.6418 4.49344 10.6418Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3909 16.3136H13.0072C13.2136 16.3136 13.381 16.1232 13.381 15.8883C13.381 15.6534 13.2136 15.4629 13.0072 15.4629H8.3909C8.18447 15.4629 8.01709 15.6534 8.01709 15.8883C8.01709 16.1232 8.18447 16.3136 8.3909 16.3136Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f162ca5af0cf76e4d5e6ec9d83bcaae1.svg";
export { ForwardRef as ReactComponent };